import { RoutesEnum } from "~/enums/routes"

export const IGNORE_LEFT_SIDEBAR_URL_NAME = [
  'account',
  'nap-tien',
  'rut-tien',
  'maintenance',
  'transaction-coin12'
]
export const IGNORE_HEADER_FOOTER = ['maintenance']
export const IGNORE_FOOTER_MOBILE_URL_NAME = [
  'transaction',
  'account',
  '404',
  'maintenance',
  'tin-tuc',
  'faq',
  'khuyen-mai',
  'search',
  'transaction-coin12',
  've-chung-toi',
  'chinh-sach-bao-mat',
  'dieu-khoan-dieu-kien',
  'cuoc-hop-phap',
  'lien-he',
]
export const IGNORE_BOTTOM_MOBILE_URL_NAME = [
  '/account/user-bank',
  '404',
  'maintenance',
  'tin-tuc',
  'faq',
  'search',
  've-chung-toi',
  'chinh-sach-bao-mat',
  'dieu-khoan-dieu-kien',
  'cuoc-hop-phap',
  'lien-he',
  'su-kien-rut-tham'
]
export const VISIBLE_LIVE_CASINO_FILTER = [`${RoutesEnum.LiveCasino}`]
export const VISIBLE_LOBDY_GAME_FILTER = [`${RoutesEnum.LobbyGame}`]
